import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import { TypeDistrict } from '../../../../types';

interface IProps {
    districtFilter: boolean;
    selectedDistrict: TypeDistrict;
    showFilterText: boolean;
    district: TypeDistrict[];
    changeDistrictFilters: (e: TypeDistrict) => void;
};

function DistrictFilter({
    districtFilter,
    selectedDistrict,
    showFilterText,
    district,
    changeDistrictFilters
}) {

    const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);
    const assessmentTypeToggle = () => setTypeDropdownOpen(prevState => !prevState);
    
  return (
    <React.Fragment>
        {districtFilter ? <Dropdown size="sm" isOpen={typeDropdownOpen} direction="down" toggle={assessmentTypeToggle}>
                    <DropdownToggle caret>
                        {selectedDistrict ? <span>District:
                            <span className="text-primary text-capitalize">
                                {selectedDistrict?.name}
                            </span>
                        </span> : `${!showFilterText ? 'All' : "Select"} District`}
                    </DropdownToggle>
                    <DropdownMenu>
                        {
                            district?.length !== 0 ? district?.map((each, index) => (
                                <DropdownItem
                                    key={index}
                                    onClick={() => {
                                        // setSelectedDistrict(each);
                                        // dispatch(setDistrictFilter(each));
                                        changeDistrictFilters(each);
                                    }}>
                                    <span className="d-flex justify-content-between align-items-center">
                                        {each?.name}
                                        {selectedDistrict?.id === each?.id && <i className="fas fa-check-circle text-primary"></i>}
                                    </span>
                                </DropdownItem>
                            )) : <span className="small text-muted text-center">No District Available</span>
                        }
                    </DropdownMenu>
                </Dropdown> : <></>}
    </React.Fragment>
  )
}

export default  React.memo(DistrictFilter);